import { useCallback, useRef, useState } from 'react';
import type { TurnstileHandle } from '../components/TurnstileWidget';

/**
 * Wires a form to a TurnstileWidget: holds the current token, and exposes a
 * reset to run after every submission so the next one gets a fresh token
 * (Turnstile tokens are single-use).
 *
 * Usage:
 *   const turnstile = useTurnstile();
 *   <TurnstileWidget ref={turnstile.ref} onToken={turnstile.setToken} />
 */
export function useTurnstile() {
  const ref = useRef<TurnstileHandle>(null);
  const [token, setToken] = useState('');

  const reset = useCallback(() => {
    setToken('');
    ref.current?.reset();
  }, []);

  return { ref, token, setToken, reset };
}
